import __base_store from '@/store/__base_store'

/**
 * Store de tipos de ruta de receta.
 */
export default __base_store({
	state: {
		model_name: 'recipe_route_type',
	},
})

